let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lusqx")).then(() => parcelRequire('1lpWv'));